import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { popIn } from '@common/utils/services';
import StockForm from '../Form';
import { fetchStock, updateStock, clearStock } from '@resources/Stock/actions';
import { Title, Modal } from '@common/components';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Update = (props) => {
	const {
		fetchStock,
		stock,
		updateStock,
		visible,
		clearStock,
		module,
		onCancel,
	} = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchStock(visible);
		};
		visible ? fetchData() : clearStock();
	}, [fetchStock, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateStock(stock._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.stock.update',
							defaultMessage:
								'An existing Stock entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[stock]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.stock',
					defaultMessage: 'Update Stock',
				})}
			</Title>
			{!isEmpty(stock) && (
				<StockForm
					data={stock}
					{...props}
					onSubmit={handleSubmit}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	stock,
	event,
	facility,
	ministry,
	mission,
	organization,
	modules,
}) => {
	return {
		stock,
		event,
		facility,
		ministry,
		mission,
		organization,
		modules,
	};
};

export default connect(mapStateToProps, {
	fetchStock,
	updateStock,
	fetchModulesBySubmoduleCode,
	clearStock,
})(Update);
